import * as React from 'react'
import { Spinner } from "react-bootstrap";
import {
  Contract,
  ContractDict,
  CustomerDict,
  OptionsAvailable,
  ProjectInvoice,
} from "../pages/KickbackProjectReportPage";
import { GroupedProjectNameAndEndDate } from "../services/API/Kickback";
import i18n from '../i18n';
interface ProjectReportValidationParams {
  validContracts: ContractDict;
  validCustomers: CustomerDict;
  existingProjects: GroupedProjectNameAndEndDate;
  availableOptions: OptionsAvailable;

}
enum KeysToSearch {
  projectName = "projectName",
  customerName = "customerName",
  customerOrgId = "customerOrgId",
  contractId = "contractId",
  billingDate = "billingDate",
  totalExclMoms = "totalExclMoms",
  tag = "tag",
  projectEndDate = "projectEndDate",
  reference = "reference",
}
type PropsKeys = Pick<ProjectReportValidationParams, "existingProjects">;
type ProjectOptions = Pick<ProjectInvoice, "reference" | "tag" | "projectName">;
type SumValidation = Pick<ProjectInvoice, "totalExclMoms">;
const _helpers = {
  checkKey: (val: string): val is KeysToSearch => {
    return val in KeysToSearch;
  },
  deepClone: (input: any): any => {
    const res = JSON.parse(JSON.stringify(input));
    return res;
  },
  convertToPercentage: (percentage: string): number => {
    let parsedPerc = +percentage.replace(",", ".");
    return parsedPerc / 100;
  },
  isValidRow:(row:ProjectInvoice):boolean => {
    if(row.customerName.length > 0 &&row.contractId.length > 0 &&row.invoiceNumber.length > 0 && row.billingDate.length > 0 && row.totalExclMoms.display.length > 0){
      return true
    }
    return false
  },

  checkDuplicates:  (x: ProjectInvoice[]): ProjectInvoice[] => {
  
    const testDuplicatesDuplicates: {
      [key: string]: { rows: number[]; rowColor: string };
    } = x.reduce(
      (
        testDuplicatesDuplicates: {
          [key: string]: { rows: number[]; rowColor: string };
        },
        item
      ) => {
       if(_helpers.isValidRow(item)){
        if (
          !testDuplicatesDuplicates[
            `${item.customerName}-${item.contractId}-${item.invoiceNumber}-${item.billingDate}-${item.totalExclMoms.value}-`
          ]
        ) {
          
          testDuplicatesDuplicates[
            `${item.customerName}-${item.contractId}-${item.invoiceNumber}-${item.billingDate}-${item.totalExclMoms.value}-`
          ] = { rows: [], rowColor: ''/*invalidColors[colorIndex]*/ };
          testDuplicatesDuplicates[
            `${item.customerName}-${item.contractId}-${item.invoiceNumber}-${item.billingDate}-${item.totalExclMoms.value}-`
          ].rows.push(item.uniqueRowId);
         // colorIndex++;
        } else {
          testDuplicatesDuplicates[
            `${item.customerName}-${item.contractId}-${item.invoiceNumber}-${item.billingDate}-${item.totalExclMoms.value}-`
          ].rows.push(item.uniqueRowId);
          if (
            testDuplicatesDuplicates[
              `${item.customerName}-${item.contractId}-${item.invoiceNumber}-${item.billingDate}-${item.totalExclMoms.value}-`
            ].rows.length > 1
          ) {
            testDuplicatesDuplicates[
              `${item.customerName}-${item.contractId}-${item.invoiceNumber}-${item.billingDate}-${item.totalExclMoms.value}-`
            ].rowColor = ''/*invalidColors[colorIndex]*/;
          }
        }
        return testDuplicatesDuplicates;
       }
       return testDuplicatesDuplicates;
       }
       
      ,
      {}
    );
    const result: ProjectInvoice[] =  _helpers.handleInvalidRowUpdate(
      testDuplicatesDuplicates,
      x
    );
    return result;
  },
  handleInvalidRowUpdate:  (
    duplicates: any,
    stateAsOffNow: ProjectInvoice[]
  ): ProjectInvoice[] => {

    let dup: ProjectInvoice[] = _helpers.deepClone(stateAsOffNow);
    if (typeof duplicates !== "undefined") {
      Object.entries(duplicates).forEach(([key, value]) => {
        if (duplicates[key].rows.length > 1) {
          const back = generateRgb()
          duplicates[key].rows.forEach((x: any) => {
            for (let index = 0; index < dup.length; index++) {
              if (dup[index].uniqueRowId == x) {
                dup[index].isDuplicate = {
                  value: true,
                  backgorundColor: back,
                };
              }
            }
          });
         
        } else {
          duplicates[key].rows.forEach((x: any) => {
            for (let index = 0; index < dup.length; index++) {
              if (dup[index].uniqueRowId == x) {
                dup[index].isDuplicate = { value: false, backgorundColor: "" };
              }
            }
           
          });
        }
      });
    }
    return dup;
  },
  checkValidNumber:(x: ProjectInvoice, key: keyof SumValidation) =>{
    //let input:ProjectInvoice = _helpers.deepClone(x)
    if (
      x[key].display[0] == "-" &&
      x[key].display.match(/[1-9,.,\s]/) !== null &&
      !x[key].display.match(/['a-öA-Ö']/)
    ) {
      x[key].valid = true;
      x[key].error = false;
      //return input
      // return {...x[key],valid:true,error:false};
    } else if (
      x[key].display.match(/^-?[0-9,.,\s]+$/) &&
      x[key].display.length > 0 &&
      !x[key].display.match(/['a-öA-Ö']/)
    ) {
      x[key].valid = true;
      x[key].error = false;
      //return input
    } else {
      x[key].valid = false;
      x[key].error = true;
      x[key].value = 0;
      x[key].display = "";
      //return input
    }
  },
  getMinOrMaxDateRange:(key: string,period:string | null): string => {
    const locale = i18n.language
    const monthNums: { [key: string]: number } = {
    };
    let monthValues = 1
    for (let index = 0; index < 12; index++) {
      
      if(!monthNums[`${new Date(2020,index).toLocaleDateString(locale,{month:'long'}).toLowerCase()}`]){
        monthNums[`${new Date(2020,index).toLocaleDateString(locale,{month:'long'}).toLowerCase()}`] = monthValues
      }
      monthValues++
    }
    let year: string | undefined = undefined
    if (typeof period == 'string'){
      year = period.split("-")[1];
    }
    if (typeof year !== "undefined") {
      const period2 =period?.split("-")[0] as string 
      const dateMax = new Date(
        +year,
        monthNums[period2.toLowerCase()],
        0
      ).getDate();
      
      const month = monthNums[period2.toLowerCase()];
      return key == "min"
        ? `${year}-${month < 10 ? "0" + month : month}-01`
        : `${year}-${month < 10 ? "0" + month : month}-${dateMax}`;
    } else {
      return "";
    }
  },
  handleHistoricProjectEndDates:(
    values: GroupedProjectNameAndEndDate,
    contracts: any[]
  ): GroupedProjectNameAndEndDate => {
    const result: GroupedProjectNameAndEndDate = {};
    contracts.reduce((result: GroupedProjectNameAndEndDate, item: any) => {
      if (!result[item.contractId]) {
        result[item.contractId] = {};
      }
      return result;
    }, result);
    if (Object.keys(values).length > 0) {
      Object.entries(values).forEach(([key, value]) => {
        if (!result[key]) {
          result[key] = {};
        } else {
          result[key] = value;
        }
      });
    }
    return result;
  },
  createContractDict:(values: any[]): ContractDict => {
    const result: ContractDict = {};
    values.reduce((result: ContractDict, item: any) => {
      if (!result[item.contractId]) {
        const contract: Contract = {
          kickbackPercent: item.kickbackPercent,
          name: item.name,
          title: item.title,
        };
        result[item.contractId] = contract;
      }
      return result;
    }, result);
    return result;
  },
  createCustomerDict:(values: any[]): CustomerDict => {
    const result: CustomerDict = {};
    values.reduce((result: CustomerDict, item: any) => {
      if (!result[item.customername]) {
        result[item.customername] = {customerOrgId:item.customerOrgId,customerId:item.customerId};
      }
      return result;
    }, result);
    return result;
  },
  buildReportPeriods:(): string[] => {   
    const locale = i18n.language
    const dateToday = new Date()
    const periods:string[] = []    
    for (let index = 5; index > 0; index--) {
      const pastDateThatHauntsMySpirit = new Date(dateToday.getFullYear(),dateToday.getMonth() - index)      
      periods.push(`${pastDateThatHauntsMySpirit.toLocaleDateString(locale,{month:'long'}).toLowerCase()}-${pastDateThatHauntsMySpirit.getFullYear()}`)     
    }
    periods.push(`${dateToday.toLocaleDateString(locale,{month:'long'}).toLowerCase()}-${dateToday.getFullYear()}`)
    return periods
    
    

  }
};
const ProjectReportValidation =   (props: ProjectReportValidationParams,dataToValidate: ProjectInvoice[]
): [ProjectInvoice[], ProjectReportValidationParams] => {
  
  let currentState: ProjectReportValidationParams = _helpers.deepClone(props);
  let input: ProjectInvoice[] = _helpers.deepClone(dataToValidate);
  try{
    for (let index = 0; index < input.length; index++) {
      // eslint-disable-next-line no-loop-func
      Object.entries(input[index]).forEach(([key, value]) => {
        if (_helpers.checkKey(key)) {
          validate(input[index], key, currentState);
        }
      });
    }
    return [input,currentState]   
  }catch(error){
    const errInp:ProjectInvoice[] = []
    return [errInp,currentState]   
  }
 
   
 
};

function validate(
  x: ProjectInvoice,
  key: keyof ProjectInvoice,
  curr: ProjectReportValidationParams
) {

  switch (key) {
    case "totalExclMoms": {
      _helpers.checkValidNumber(x, key);
      break;
    }

    case "customerName":
    case "customerOrgId": {
      checkValidCustomer(x, curr);
      break;
    }

    case "contractId": {
      validateContractId(x, key,curr);
      break;
    }
    case "reference":
    case "tag":
    case "projectName": {
      const res = validateOptions(x, key, curr, "existingProjects");
      curr.availableOptions[key as keyof ProjectOptions] = res[0];
      curr["existingProjects"] = res[1];
    }
  }
}

function validateOptions(
  x: ProjectInvoice,
  key: keyof ProjectOptions,
  curr: ProjectReportValidationParams,
  keyForProj: keyof PropsKeys
): [string[], GroupedProjectNameAndEndDate] {
  
  if (key == "projectName") {
    const res = _helpers.deepClone(curr.availableOptions[key]) as (typeof curr.availableOptions)[typeof key];
    const projectDates: GroupedProjectNameAndEndDate = _helpers.deepClone(curr[keyForProj]) as (typeof curr)[typeof keyForProj];
      
    if (typeof res.find((q) => q == x.projectName)?.valueOf() == "undefined") {
      res.push(x.projectName);
    }
    const reg = new RegExp(/\d{4}-\d{2}-\d{2}/);

    const correctFormat = x.projectEndDate.match(reg);
    const billingDateFormat = x.billingDate.match(reg);
    if(Object.keys(projectDates).length > 0 && typeof projectDates[x.contractId] !== 'undefined'){
      if (typeof projectDates[x.contractId][x.projectName] !== 'undefined') {
        projectDates[x.contractId][x.projectName] = correctFormat == null? typeof projectDates[x.contractId][x.projectName] !== "undefined"
              ? projectDates[x.contractId][x.projectName]
              : null
            : x.projectEndDate;
      } else if (
        !projectDates[x.contractId][x.projectName] &&
        correctFormat !== null
      ) {
        projectDates[x.contractId][x.projectName] = x.projectEndDate;
      }
  
      x.projectEndDate =correctFormat !== null? x.projectEndDate: projectDates[x.contractId][x.projectName]?.toString() ?? "";
      x.billingDate = billingDateFormat !== null ? x.billingDate : ''
      return [res, projectDates];
    }
    x.projectEndDate = ""
    x.billingDate = billingDateFormat !== null ? x.billingDate : ''
    return [res,projectDates]
   
  } else {
    const res = _helpers.deepClone(
      curr.availableOptions[key]
    ) as (typeof curr.availableOptions)[typeof key];
    if (typeof res.find((q) => q == x[key])?.valueOf() == "undefined") {
      res.push(x[key]);
    }
    return [res, curr[keyForProj]];
  }
}

function validateContractId(
  x: ProjectInvoice,
  key:string,
  curr: Readonly<ProjectReportValidationParams>
) {
  
  if (typeof curr.validContracts[x["contractId"]] == "undefined") {
    x["contractId"] = "";
  } else {
    x["kick"] = _helpers.convertToPercentage(
      curr.validContracts[x["contractId"]].kickbackPercent
    );
  }
}
function checkValidCustomer(
  x: ProjectInvoice,
  curr: Readonly<ProjectReportValidationParams>
) {
  if (typeof curr.validCustomers[x["customerName"]] == "undefined") {
    x["customerName"] = "";
    x["customerOrgId"] = "";
  }
}
function generateRgb():string{
  const minCeiled = Math.ceil(1);
  const maxFloored = Math.floor(255);

  Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled)
  return `rgb(${getStringNum()},${getStringNum()},${getStringNum()},0.2)`
}
function getStringNum():number{
  const minCeiled = Math.ceil(1);
  const maxFloored = Math.floor(255);

 return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled)
}
interface OverlayProps {
  val:boolean;
}

const OverLay = ({val}:OverlayProps): JSX.Element => {

    const [internalState,setState] = React.useState(false)
    React.useEffect(() => {setState(val)},[val])
      return (
    <>
   
      {internalState ? (
        <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          color: "white",
          backgroundColor: "rgba(0, 0, 0, 0.685)",
          width: "100%",
          height: "100vh",
          top: 0,
          left: 0,
          zIndex: 9998,
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        >
          <Spinner />
        </div>
      ) : (
        <></>
        )}
        
    </>
  );
};

export { ProjectReportValidation, _helpers, OverLay };
